import {useEffect, useState,} from 'react'
import {
    Box,Spinner,
    Flex, Grid, GridItem,
    Heading, Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    useDisclosure, useToast
} from '@chakra-ui/react'
import Area from "./Area";
import {useParams} from "react-router-dom";
import useCalculator from "../../../core/hooks/useCalculator";
import httpRequest from "../../../core/services/http-request";
import {useGetReport, useUser} from "../../../core/hooks";
import {REPORT_TYPE, SPECIFICATIONS_TYPE} from "../../../constants/orders/orderEnum";
import CustomSpinner from '../../../components/Spinner/CustomSpinner';
import {EU, REU,SUPERADMIN} from "../../../constants/user/userEnum";

const IlluminationAreas = ({proposal,  setLuminaire, luminaire,project}) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [modalType, setModalType] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null);
    const params = useParams()
    const {calculate, data, isLoading: isLoadingCalculator} = useCalculator(params.reportId)
    const {post, postPdf} = httpRequest()
    const [proposalResponseData, setProposalResponseData] = useState([])
    const [calcNumbers, setCalcNumbers] = useState({})
    const [financed, setFinanced] = useState(0)
    const {data: reportDataResponse, refetch: refetchReport} = useGetReport(params.reportId)
    const [downloadingPDF, setDownloadingPDF] = useState({type: 'pdf', bool: false, id:null})
    const [downloadingMapPDF, setDownloadingMapPDF] = useState({type: 'pdf', bool: false, id:null})
    const [pdfLoading, setPdfLoading] = useState(null);
    const [mapPdfLoading, setMapPdfLoading] = useState(null);
    const [ledFinanced, setLedFinanced] = useState([])
    const [projectTotal, setProjectTotal] = useState(0)
    const [totalLoanPdf, setTotalLoanPdf] = useState(0)
    const [totalLoan, setTotalLoan] = useState(0)
    const [yearOneLed, setYearOneLed] = useState(0)
    const toast = useToast();
    const {user} = useUser()

    useEffect(() => {
        if (projectTotal === 0) return
        let total = 0
        let arr = []
        total = (((projectTotal - project.depositAmount) / 100) * project.interestRate) + (projectTotal - project.depositAmount)
        setTotalLoan(total)
        setTotalLoanPdf(total)
        let principalLoanAmount = projectTotal - Number(project.depositAmount)
        let interestDue = principalLoanAmount * Number(project.interestRate)/100
        let totalLoanAmount = principalLoanAmount + interestDue
        let durationYears = Number(project.loanPeriod) / 12
        let annualAmountPaidYear = (totalLoanAmount / durationYears)

        arr.push(project.depositAmount)
        for (let i = 1; i <= 10; i++) {
            if (i <= durationYears){
                arr.push(Math.round((yearOneLed+annualAmountPaidYear)*i))
            } else {
                arr.push(Math.round((yearOneLed*i))+totalLoanAmount)
            }
        }
        setLedFinanced(arr)
        setFinanced(arr)
        console.log(proposal)
        console.log(luminaire)
    }, [projectTotal])


    useEffect(() => {
        if (!proposal) return
        const lumins = []
        for (let i = 0; i < proposal?.proposal?.length; i++) {
            for (let j = 0; j < proposal.proposal[i].luminaires?.length; j++) {
                if (proposal.proposal[i].luminaires[j]?.lampRecomendedAirtable?.length > 0) {
                    lumins.push(proposal.proposal[i].luminaires[j])
                }
                if (proposal.proposal[i].luminaires[j]?.fixtureRecomendedAirtableArray?.length > 0) {
                    lumins.push(proposal.proposal[i].luminaires[j])
                }
            }
        }
        let groupedLumins = new Map()
        lumins.forEach((item) => {
            const key = [
                item.fixtureDescription,
                item.lampPerFixture,
                item.lampDescription,
                item.powerSupplyDescription,
                item.controlDescription,
                item.accessoryDescriptionA,
                item.accessoryDescriptionB,
                item.accessoryDescriptionC,
            ].join('|')

            if (groupedLumins.has(key)) {
                groupedLumins.get(key).qty += Number(item.qty);
                groupedLumins.get(key).recomendedFixtureQty += Number(item.recomendedFixtureQty);
            } else {
                groupedLumins.set(key, { ...item, qty: item.qty ? Number(item.qty) : 0, recomendedFixtureQty: item.recomendedFixtureQty ? Number(item.recomendedFixtureQty) : 0 });
            }
        });

        const result = Array.from(groupedLumins.values());
        setLuminaire(result)
    }, [proposal])

    // useEffect(() => {
    //     if (downloadingPDF.bool) {
    //         downloadReportPdf();
    //     }
    // }, [downloadingPDF]);
    function getCurrentDateFormatted() {
        const currentDate = new Date()
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0')
        const day = currentDate.getDate().toString().padStart(2, '0')
        const year = currentDate.getFullYear().toString().substr(-2)
        return `${month}.${day}.${year}`
    }
    const downloadReportPdf = (item) => {
        setDownloadingPDF({ type: 'pdf', bool: true, id: item.id })
        const iesFilesArray = item.luminaires.map((luminaire) => {
            return luminaire?.lampRecomendedAirtableArray?.[0]?.fields?.['IES File (hyperlink)'] || '';
        });
        let resp = {
            reportId: params.reportId,
            calculate: calcNumbers,
            totalLoan: totalLoanPdf,
            financed: financed,
            pdfType: downloadingPDF.type === 'spec' ? SPECIFICATIONS_TYPE: SPECIFICATIONS_TYPE,
            iesFiles: iesFilesArray
        }
        postPdf('download-illumination-report-ies-files', resp).then((response) => {
            const blob = new Blob([response.data], {type: 'application/pdf'});
            const formattedDate = getCurrentDateFormatted();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${proposalResponseData?.project.address  + ' - ' + formattedDate + ' IES File'}.pdf`;
            a.click();
            window.URL.revokeObjectURL(url);
            setDownloadingPDF({ type: 'pdf', bool: false, id:null })
        }).catch(() => {
            setDownloadingPDF({ type: 'pdf', bool: false, id:null })
            toast({
                title: "Failed to load PDF",
                description: "Some items are missing in the created report. Please try again.",
                status: "error",
                duration: 4000,
                isClosable: true,
                position: "top-right",
            });
        })
    }
    const previewReportPdf = (item) => {
        setPdfLoading(item.id);
        const iesFilesArray = item.luminaires.map((luminaire) => {
            return luminaire?.lampRecomendedAirtableArray?.[0]?.fields?.['IES File (hyperlink)'] || '';
        });

        let resp = {
            reportId: params.reportId,
            calculate: calcNumbers,
            totalLoan: totalLoanPdf,
            financed: financed,
            pdfType: SPECIFICATIONS_TYPE,
            iesFiles: iesFilesArray
        };
        postPdf('download-illumination-report-ies-files', resp)
            .then((response) => {
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                setPdfUrl(url);
                setSelectedItem(item);
                setModalType("pdf");
                setPdfLoading(null);
                onOpen();
            })
            .catch(() => {
                setPdfUrl(null);
                setPdfLoading(null);
                toast({
                    title: "Failed to load PDF",
                    description: "Something went wrong while generating the preview. Please try again.",
                    status: "error",
                    duration: 4000,
                    isClosable: true,
                    position: "top-right",
                });
            });
    };
    const previewReportMapPdf = (item) => {
        setMapPdfLoading(item.id);
        let resp = {
            reportId: params.reportId,
            calculate: calcNumbers,
            totalLoan: totalLoanPdf,
            financed: financed,
            pdfType: SPECIFICATIONS_TYPE,
            illuminationReport: project?.areas[0]?.illuminationReport ?? ''
        };
        postPdf('download-report-map', resp)
            .then((response) => {
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                setPdfUrl(url);
                setSelectedItem(item);
                setModalType("pdf");
                setMapPdfLoading(null);
                onOpen();
            })
            .catch(() => {
                setPdfUrl(null);
                setMapPdfLoading(null);
                toast({
                    title: "Failed to load PDF",
                    description: "Something went wrong while generating the preview. Please try again.",
                    status: "error",
                    duration: 4000,
                    isClosable: true,
                    position: "top-right",
                });
            });
    };
    const downloadReportMapPdf = (item) => {
        setDownloadingMapPDF({ type: 'pdf', bool: true, id:item.id })
        let resp = {
            reportId: params.reportId,
            calculate: calcNumbers,
            totalLoan: totalLoanPdf,
            financed: financed,
            pdfType: downloadingPDF.type === 'spec' ? SPECIFICATIONS_TYPE: SPECIFICATIONS_TYPE,
            illuminationReport: project?.areas[0]?.illuminationReport ?? ''
        }
        postPdf('download-report-map', resp).then((response) => {
            const blob = new Blob([response.data], {type: 'application/pdf'});
            const formattedDate = getCurrentDateFormatted();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${proposalResponseData?.project.address  + ' - '  + formattedDate + 'Illumination Report'}.pdf`;
            a.click();
            window.URL.revokeObjectURL(url);
            setDownloadingMapPDF({ type: 'pdf', bool: false, id:null })
        }).catch(() => {
            setDownloadingMapPDF({ type: 'pdf', bool: false, id:null })
            toast({
                title: "Failed to load PDF",
                description: "Some items are missing in the created report. Please try again.",
                status: "error",
                duration: 4000,
                isClosable: true,
                position: "top-right",
            });
        })
    }

    // useEffect(() => {
    //     if (downloadingMapPDF.bool) {
    //         downloadReportMapPdf();
    //     }
    // }, [downloadingMapPDF]);

    useEffect(() => {
        if (!reportDataResponse) return
        calculate()
        setProposalResponseData(reportDataResponse.data.data)
    }, [reportDataResponse])
    useEffect(() => {
        if (!data) return
        let results = data.data.data
        results.installation = proposalResponseData?.installation?.total ? proposalResponseData?.installation?.total?.toLocaleString('en-US') : 0
        setCalcNumbers(results)
        setProjectTotal(results.projectTotal)
        setYearOneLed(results.yearOneLed)
    }, [data])
    return (
        <>
            <Grid
                templateColumns={
                    user?.type === "SUPERADMIN"
                        ? "2fr 1fr 1fr"
                        : "2fr auto"
                }
                fontFamily='Titillium Web'
                fontSize='18px'
                color='#193C5B'
                // borderBottom="1px solid #C4C4C4"
            >
                <Box fontWeight="bold" p={3}>
                    Areas
                </Box>

                {user?.type === "SUPERADMIN" && (
                    <Box
                        fontWeight="bold"
                        p={3}
                        textAlign="center"
                    >
                        IES Files
                    </Box>
                )}

                <Box fontWeight="bold" p={3} textAlign="center">
                    Maps
                </Box>
            </Grid>

            <Box maxWidth="1240px" display="grid" gap="20px">
                {luminaire
                    ?.filter((filtered) => filtered?.luminaires?.length > 0)
                    .map((item) => (
                        <Grid
                            key={item.id}
                            templateColumns={
                                user?.type === "SUPERADMIN"
                                    ? "1fr 1fr 1fr 1fr"
                                    : "2fr auto"
                            }
                            borderTop="1px solid #E0E0E0"
                            borderBottom="1px solid #E0E0E0"
                            borderRight="1px solid #E0E0E0"
                            borderLeft="1px solid #E0E0E0"
                            borderRadius='6px'
                            _hover={{ bg: "#F5F5F5" }}
                        >
                            {/* Area Name */}
                            <GridItem
                                colSpan={user?.type === "SUPERADMIN" ? 2 : 1}
                            >
                                <Box
                                    p={3}
                                    color="#2C628D"
                                    fontWeight="500"
                                    fontSize='14px'
                                    fontFamily='Frank Ruhl Libre'
                                >
                                    {item.title}
                                </Box>
                            </GridItem>

                            {/* IES Files (only for SUPERADMIN) */}
                            {user?.type === "SUPERADMIN" && (
                                <Flex
                                    align="center"
                                    justify="center"
                                    gap='5px'
                                    p={2}
                                >
                                    <Box as="span" cursor="pointer">
                                        {pdfLoading === item.id ? (
                                            <Spinner
                                                thickness="2px"
                                                speed="0.45s"
                                                color="gray.400"
                                                boxSize="12px"
                                            />
                                        ) : (
                                            <img
                                                src="/icons/eye_icon.svg"
                                                onClick={() => previewReportPdf(item)}
                                                alt="eye_icon"
                                            />
                                        )}
                                    </Box>
                                    <Box as="span" cursor="pointer">
                                        {/*<img*/}
                                        {/*    src="/icons/cloud_upload.svg"*/}
                                        {/*    onClick={(e) => {*/}
                                        {/*        e.stopPropagation();*/}
                                        {/*        setDownloadingPDF({ type: "print", bool: true, id: item.id });*/}
                                        {/*    }}*/}
                                        {/*    alt="cloud_upload"*/}
                                        {/*/>*/}
                                        {downloadingPDF.bool && downloadingPDF.id === item.id ? (
                                            <Spinner
                                                thickness="2px"
                                                speed="0.45s"
                                                color="gray.400"
                                                boxSize="12px"
                                            />
                                        ) : (
                                            <img
                                                src="/icons/cloud_upload.svg"
                                                // onClick={(e) => {
                                                //     e.stopPropagation();
                                                //     setDownloadingPDF({ type: 'print', bool: true, id: item.id })
                                                // }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    downloadReportPdf(item)
                                                }}
                                                alt="cloud_upload"
                                            />
                                        )}
                                    </Box>
                                </Flex>
                            )}

                            {/* Maps */}
                            <Flex align="center" justify="center" gap='5px' pr={user?.type === REU ? "15px" : "0"}>
                                <Box as="span" cursor="pointer">
                                    {mapPdfLoading === item.id ? (
                                        <Spinner
                                            thickness="2px"
                                            speed="0.45s"
                                            color="gray.400"
                                            boxSize="12px"
                                        />
                                    ) : (
                                        <img
                                            src="/icons/eye_icon.svg"
                                            onClick={() => previewReportMapPdf(item)}
                                            alt="eye_icon"
                                        />
                                    )}
                                </Box>
                                <Box as="span" cursor="pointer">
                                    {downloadingMapPDF.bool && downloadingMapPDF.id === item.id ? (
                                        <Spinner
                                            thickness="2px"
                                            speed="0.45s"
                                            color="gray.400"
                                            boxSize="12px"
                                        />
                                    ) : (
                                        <img
                                            src="/icons/cloud_upload.svg"
                                            // onClick={(e) => {
                                            //     e.stopPropagation();
                                            //     setDownloadingMapPDF({ type: 'print', bool: true, id: item.id })
                                            // }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                downloadReportMapPdf(item)
                                            }}
                                            alt="cloud_upload"
                                        />
                                    )}
                                </Box>
                            </Flex>
                        </Grid>
                    ))}
            </Box>
            <Modal isOpen={isOpen} onClose={onClose} size="6xl">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        {modalType === "view" ? "View Item Details" : proposal?.proposalName}
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {modalType === "pdf" && pdfUrl && (
                            <Box h="600px">
                                <iframe
                                    src={pdfUrl}
                                    width="100%"
                                    height="100%"
                                    style={{ border: "none" }}
                                    title="PDF Preview"
                                    onLoad={() => setPdfLoading(null)}
                                />
                            </Box>
                        )}
                        {modalType === "delete" && (
                            <Box>Are you sure you want to delete this item?</Box>
                        )}
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    )
}

export default IlluminationAreas